import { useAppSelector } from "../../common/redux/hooks";

export const useBasicBidState = () => {
  const bidState = useAppSelector((state) => state.basicBid.bid);
  if (!bidState) throw Error("No bid state found.");
  return bidState;
};
